import React from 'react';
import './CurriculumSection.css';

const CurriculumSection: React.FC = () => {
  return (
    <section className="curriculum-section">
      <div className="container">
        <div className="curriculum-content">
          <div className="curriculum-text">
            <h3>In Association With</h3>
            <div className="logo-container">
              <div className="partner-logo">
                <img 
                  src="/images/iiit-delhi.png" 
                  alt="IIIT Delhi" 
                  className="partner-logo-img"
                  title="IIIT Delhi"
                />
              </div>
              <div className="partner-logo">
                <img 
                  src="/images/iiit.png" 
                  alt="IIIT Delhi" 
                  className="partner-logo-img"
                  title="IIIT Delhi"
                  style={{ objectFit: 'contain' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CurriculumSection;
